import { render, staticRenderFns } from "./modal-workboard.vue?vue&type=template&id=45d4c94d&"
import script from "./modal-workboard.vue?vue&type=script&lang=ts&"
export * from "./modal-workboard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports